import { type FC } from 'react'

import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantSelectOption } from 'modules/it_management/components/device_catalog/DeviceVariantSelector/types'
import { F0Select } from '@factorialco/f0-react'
import { Keyboard } from '@factorialco/f0-react/icons/app'

export interface DeviceVariantSelectProps {
  variant: DeviceVariantSelectOption
  value?: string
  onChange: (value: string) => void
}

export const DeviceVariantSelect: FC<DeviceVariantSelectProps> = ({ variant, value, onChange }) => {
  return (
    <div className="flex flex-col">
      <SectionHeader title={variant.title} description={''} />
      <div className="flex flex-col gap-2">
        <F0Select
          onChange={onChange}
          options={variant.variants.map((option) => {
            return {
              icon: Keyboard,
              label: option.name,
              value: option.id,
            }
          })}
          value={value}
        />
      </div>
    </div>
  )
}
